import detail from '@/pages/serviceScore/detail'
import * as service from './service'
import status from '@/pages/testReport/status'
export default {
  namespace: 'recruitMain',
  state: {
    cancelChangeCity: 0,
    listData: [],
    loadingError: false,
    isLoading: false,
    detailData: {
    },
    businessType: 0,
    status: 0
  },
  effects: {
    * list ({ payload }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          isLoading: true
        }
      })
      const res = yield call(service.list, payload)
      yield put({
        type: 'save',
        payload: {
          isLoading: false
        }
      })
      const httpCode = res.status
      const successCode = 200
      const clientErrorCode = 400
      if (httpCode >= successCode && httpCode < clientErrorCode) {
        yield put({
          type: 'save',
          payload: {
            listData: res.data.data.stepList || [],
            cancelChangeCity: res.data.data.cancelChangeCity,
            mobile: res.data.data.mobile,
            businessType: res.data.data.businessType,
            status: res.data.data.status
          }
        })
      } else {
        yield put({
          type: 'save',
          payload: {
            listData: [],
            loadingError: true
          }
        })
      }
      console.log('res', res)
      return res
    },
    * cancelChangeCity ({ payload }, { call, put }) {
      const res = yield call(service.cancelChangeCity, payload)
      return res
    },
    * courierAge ({ payload }, { call, put }) {
      try {
        const res = yield call(service.courierAge, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    },
    * detail ({ payload }, { call, put }) {
      try {
        const res = yield call(service.detail, payload)
        const { data, status } = res.data
        if (status === 200) {
          yield put({
            type: 'save',
            payload: {
              detailData: data
            }
          })
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
